export default __webpack_public_path__ + "static/media/videot.364cbdfe.mp4";